import React from 'react';
import LegalPage from '../components/LegalPage';

const refundContent = [
  {
    title: 'Overview',
    description:
      'This Refund &amp; Cancellation Policy explains how cancellations, refunds, and related requests are handled for services and products offered by <strong>ServerPe App Solutions</strong>. By engaging our services or purchasing any of our products, you agree to the terms outlined below.',
  },
  {
    title: 'Custom Development Services',
    description:
      'Custom web and mobile development projects are typically billed in milestones. Once work has begun on a milestone, the effort already delivered is non-refundable. If you wish to cancel an ongoing engagement, please contact us — any unutilised advance for work not yet started may be refunded at our discretion after deducting costs already incurred.',
  },
  {
    title: 'Subscriptions &amp; SaaS Products',
    description:
      'For subscription-based products (such as AlertMyVahan, VerifyVahan, and other SaaS offerings), you may cancel your subscription at any time. Cancellation stops future renewals. Payments already made for the current billing cycle are generally non-refundable, and access continues until the end of the paid period unless stated otherwise on the specific product page.',
  },
  {
    title: 'Eligibility for Refunds',
    description:
      'Refunds may be considered in cases such as: a duplicate payment, a failed transaction where the amount was debited but the service was not activated, or a verified technical issue on our side that prevented delivery of the paid service. Refunds are not provided for change of mind after a service has been delivered or consumed.',
  },
  {
    title: 'How to Request a Refund or Cancellation',
    description:
      'To request a cancellation or refund, email us at <a href="mailto:support@serverpe.in" style="color:#2563eb;font-weight:600;">support@serverpe.in</a> with your name, registered contact details, the product or service concerned, and the reason for your request. Please raise refund requests within 7 days of the transaction.',
  },
  {
    title: 'Processing Time',
    description:
      'Approved refunds are processed to the original payment method. Once approved, refunds are typically initiated within 5–7 business days. The time taken for the amount to reflect in your account depends on your bank or payment provider.',
  },
  {
    title: 'Contact Us',
    description:
      'For any questions regarding this policy, reach out to ServerPe App Solutions at <a href="mailto:support@serverpe.in" style="color:#2563eb;font-weight:600;">support@serverpe.in</a>. We are based in Bengaluru, Karnataka, India.',
  },
];

const RefundAndCancellationPolicy = () => (
  <LegalPage
    title="Refund & Cancellation Policy"
    subtitle="How ServerPe App Solutions handles cancellations, refunds, and related requests."
    staticContent={refundContent}
    accentColor="#2563eb"
  />
);

export default RefundAndCancellationPolicy;
